import "./page-loading-skeleton.css";

export type LoadingLayout = "table" | "rows" | "cards" | "gallery" | "detail" | "form";

/** Loading geometry only: never supplies business values or interactive controls. */
export function PageLoadingSkeleton({ layout = "table", label = "正在加载", heading = false, rows = 5, className = "" }: {
  layout?: LoadingLayout;
  label?: string;
  heading?: boolean;
  rows?: number;
  className?: string;
}) {
  const count = layout === "detail" ? 2 : layout === "form" ? 4 : rows;
  return <div className={`spa-loading-skeleton is-${layout} ${className}`} role="status" aria-busy="true" aria-label={label}>
    <span className="spa-skeleton-label">{label}</span>
    <div aria-hidden="true">
      {heading ? <div className="spa-skeleton-heading"><span className="spa-skeleton-block" /><span className="spa-skeleton-block" /></div> : null}
      <div className="spa-skeleton-body">
        {Array.from({ length: count }, (_, index) => <div className="spa-skeleton-item" key={index}>
          {layout === "rows" || layout === "cards" || layout === "gallery" ? <span className="spa-skeleton-block spa-skeleton-image" /> : null}
          <div className="spa-skeleton-copy"><span className="spa-skeleton-block" /><span className="spa-skeleton-block is-short" /></div>
          {layout === "table" || layout === "detail" ? <><span className="spa-skeleton-block" /><span className="spa-skeleton-block is-short" /></> : null}
        </div>)}
      </div>
    </div>
  </div>;
}
